import instance from "./instance";

export const downloadPdf = async (fullname, test, id) => {
  try {
    const response = await instance.get(`results/${id}/pdf/`, {
      responseType: "blob",
    });

    const clean = (str) =>
      str
        .trim()
        .replace(/[^\w\sа-яА-ЯёЁ-]/gi, "")
        .replace(/\s+/g, "_");

    const filename = `${clean(test)}_${clean(fullname) || "результат"}.pdf`;
    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();

    // Очистка
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Ошибка при загрузке PDF:", error);
    throw error;
  }
};

export const getPdfUrl = (id) => {
  return `https://hr.kzn.ru/api/results/${id}/pdf/`;
}

export const postTestResult = async (formData) => {
  try {
    const response = await instance.post("results/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Ошибка при отправке результата:", error);
    throw error;
  }
};

const buildQueryString = (params = {}) => {
  const searchParams = new URLSearchParams();

  if (params.page) searchParams.append("page", params.page);
  if (params.search) searchParams.append("search", params.search);
  if (params.test_name) searchParams.append("test_name", params.test_name);
  if (params.date_taken) searchParams.append("date_taken", params.date_taken);

  return `?${searchParams.toString()}`;
};

export const getTestResults = async (params = {}) => {
  const url = `/results/${buildQueryString(params)}`;
  try {
    const response = await instance.get(url);
    return response.data;
  } catch (error) {
    console.error("Ошибка при получении результатов:", error);
    throw error;
  }
};

export const deleteResultById = async (id) => {
  const url = `/results/${id}/`;
  try {
    await instance.delete(url);
    return true;
  } catch (error) {
    console.log(error.response?.data?.detail || "Ошибка удаления");
    return false;
  }
};
